export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/noop.js
// module id = PWxq
// module chunks = 0